import { Button, useAccordionButton } from 'react-bootstrap';
import React from 'react';

export default function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey);

  return (
    <Button type="button" className="btn-select w-100 mb-2" onClick={decoratedOnClick}>
      {children}
    </Button>
  );
}

export function CustomToggleSubmit({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey);

  return (
    <Button type="submit" className="btn-select float-end mb-2" onClick={decoratedOnClick}>
      {children}
    </Button>
  );
}
